import { render, staticRenderFns } from "./KlinikEksekutif.vue?vue&type=template&id=14f77827"
import script from "./KlinikEksekutif.vue?vue&type=script&lang=js"
export * from "./KlinikEksekutif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports